import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createStyles, Divider, Grid, makeStyles } from '@material-ui/core';
import { SignUpTerms } from './SignUpTerms';
import { SocialButtonContent } from './SocialButtonContent';
export var useSocialSignUpFormStyles = makeStyles(function (_a) {
    var spacing = _a.spacing, typography = _a.typography, palette = _a.palette;
    return createStyles({
        grid: {
            '& .MuiGrid-item': {
                marginBottom: spacing(1.5),
            },
        },
        formSeparator: {
            borderColor: palette.secondary.main,
            borderTopWidth: spacing(0.125),
            borderStyle: 'solid',
            height: spacing(0.125),
            margin: spacing(1.75, 0),
            '& p': {
                fontFamily: typography.fontFamily,
                color: palette.secondary.main,
                fontSize: typography.fontSize - 1,
                fontWeight: typography.fontWeightBold,
                textAlign: 'center',
                margin: spacing(-1.125, 'auto'),
                backgroundColor: palette.common.white,
                display: 'block',
                width: spacing(3.75),
            },
        },
        center: {
            textAlign: 'center',
            '&.MuiGrid-item': {
                marginBottom: function (_a) {
                    var hideLogin = _a.hideLogin;
                    return (hideLogin ? spacing(2) : spacing(1.5));
                },
            },
        },
        buttonLink: {
            borderStyle: 'none',
            background: 'none',
            fontFamily: typography.fontFamily,
            fontSize: typography.body2.fontSize,
            fontWeight: typography.fontWeightBold,
            color: palette.tertiary.main,
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        member: {
            paddingTop: spacing(1.75),
            fontFamily: typography.fontFamily,
            fontSize: typography.body1.fontSize,
        },
        separator: {
            '& hr': {
                backgroundColor: palette.secondary.main,
                margin: spacing(1.75, 0),
            },
        },
        terms: {
            '&.MuiGrid-item': {
                marginBottom: 0,
            },
        },
        formSeparator_loh: {
            borderColor: palette.border.disabled,
            borderTopWidth: spacing(0.125),
            borderStyle: 'solid',
            height: spacing(0.125),
            margin: spacing(1.75, 0),
            '& p': {
                fontFamily: typography.fontFamily,
                color: palette.border.disabled,
                fontSize: typography.fontSize - 1,
                fontWeight: typography.fontWeightBold,
                textAlign: 'center',
                margin: spacing(-1.125, 'auto'),
                backgroundColor: palette.secondary.main,
                display: 'block',
                width: spacing(3.75),
            },
        },
        buttonLink_loh: {
            borderStyle: 'none',
            background: 'none',
            fontFamily: typography.fontFamily,
            fontSize: typography.body2.fontSize,
            fontWeight: typography.fontWeightBold,
            color: palette.primary.main,
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        separator_loh: {
            '& hr': {
                backgroundColor: palette.border.disabled,
                margin: spacing(1.75, 0),
            },
        },
        member_loh: {
            paddingTop: spacing(1.75),
            fontFamily: typography.fontFamily,
            fontSize: typography.body1.fontSize,
            color: palette.border.disabled,
        },
    });
});
export function SocialSignUpForm(props) {
    var redirectTo = props.redirectTo, _a = props.hideLogin, hideLogin = _a === void 0 ? false : _a, _b = props.excludeTitle, excludeTitle = _b === void 0 ? false : _b, switchToEmailSignUp = props.switchToEmailSignUp, _c = props.switchToLogin, switchToLogin = _c === void 0 ? function () { } : _c, _d = props.isLoggedOutHome, isLoggedOutHome = _d === void 0 ? false : _d, _e = props.showAuth0, showAuth0 = _e === void 0 ? false : _e;
    var classes = useSocialSignUpFormStyles(props);
    var handleEmailSignUp = function (event) {
        event.preventDefault();
        switchToEmailSignUp(true);
    };
    var handleLogin = function (event) {
        event.preventDefault();
        switchToLogin(true);
    };
    var intl = useIntl();
    var socialSignUpFormMessages = defineMessages({
        orSeparatorMessage: {
            id: 'authentication.social-sign-up-form.separator',
            description: 'Text use to separate two options for sign up: using a social media account OR using email and password.',
            defaultMessage: 'or',
        },
        signUpWithEmailMessage: {
            id: 'authentication.social-sign-up-form.btn.sign-in.logged-out',
            description: 'Sign up button text - When logged out',
            defaultMessage: 'Sign Up With Email',
        },
        signUpUsingEmailMessage: {
            id: 'authentication.social-sign-up-form.btn.sign-in.logged-in.excluded-title',
            description: 'Sign up button text - When logged and title is excluded',
            defaultMessage: 'Sign up using Email',
        },
        signUpUsingEmailCamelCaseMessage: {
            id: 'authentication.social-sign-up-form.btn.sign-in.logged-in.not-excluded-title',
            description: 'Sign up button text - When logged and title is not excluded',
            defaultMessage: 'Sign Up Using Email',
        },
        alreadyMemberMessage: {
            id: 'authentication.social-signup-form.question',
            description: 'Already a member question text',
            defaultMessage: 'Already a member?\u00A0',
        },
        btnSignInMessage: {
            id: 'authentication.social-sign-up-form.btn.sign-in',
            description: 'Sign in button text',
            defaultMessage: 'Sign In',
        },
    });
    return (React.createElement(Grid, { container: true, className: classes.grid },
        React.createElement(SocialButtonContent, { redirectTo: redirectTo, isSignUp: true, isLoggedOutHome: isLoggedOutHome, showAuth0: showAuth0 }),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement("div", { className: "form-separator " + (isLoggedOutHome ? classes.formSeparator_loh : classes.formSeparator) },
                React.createElement("p", null, intl.formatMessage(socialSignUpFormMessages.orSeparatorMessage)))),
        React.createElement(Grid, { item: true, xs: 12, className: classes.center }, isLoggedOutHome ? (React.createElement("button", { className: classes.buttonLink_loh, onClick: handleEmailSignUp }, intl.formatMessage(socialSignUpFormMessages.signUpWithEmailMessage))) : (React.createElement("button", { className: classes.buttonLink, onClick: handleEmailSignUp }, excludeTitle
            ? intl.formatMessage(socialSignUpFormMessages.signUpUsingEmailMessage)
            : intl.formatMessage(socialSignUpFormMessages.signUpUsingEmailCamelCaseMessage)))),
        !hideLogin && (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 12, className: classes.center },
                React.createElement("div", { className: isLoggedOutHome ? classes.member_loh : classes.member },
                    intl.formatMessage(socialSignUpFormMessages.alreadyMemberMessage),
                    React.createElement("button", { className: isLoggedOutHome ? classes.buttonLink_loh : classes.buttonLink, onClick: handleLogin }, intl.formatMessage(socialSignUpFormMessages.btnSignInMessage)))),
            React.createElement(Grid, { item: true, xs: 12, className: isLoggedOutHome ? classes.separator_loh : classes.separator },
                React.createElement(Divider, null)))),
        React.createElement(Grid, { className: classes.terms, item: true, xs: 12 },
            React.createElement(SignUpTerms, { hideCaptchaTerms: true, isLoggedOutHome: isLoggedOutHome }))));
}
//# sourceMappingURL=SocialSignUpForm.js.map